import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading';
import Printd from 'printd';
import Multiselect from 'vue-multiselect'

export default {
	name: 'transcational-logs',
	components: {
		Paginate,
		DatePicker,
		BasicSelect,
		VueElementLoading,
		Multiselect
	},
	data: function() {
		return {
			sourcehublist: [],
			isSourceError: '',
			sourcehubitem: {
				id: '',
				text: ''
			},
			HubID: '',
			hubLoading: '',
			pageCount: 0,
			pageNo: 0,
			limit: 10,
			totalRows: 0,
			fromdate: '',
			todate: '',
			showResponseModal: false,
			showRequestModal: false,
			responseLogData: [],
			requestLogData: {},
			logTypeData: '',
			isLoading: false,
			createdBy: "",
			transactionalLogsData: [],
			exceptionalLogsData: [],
			sorterExceptionLogData:[],
			showTransactionLogTable: false,
			showExceptionLogTable: false,
			showSorterExceptionLogTable:false,
			appTypeData: '',
			bagno: '',
			shippingid: '',
			appTypeArr: [{
					id: 1,
					type: 'MasterAPI'
				},
				{
					id: 2,
					type: 'UpdateFramework'
				}, {
					id: 3,
					type: 'HubOps'
				}, {
					id: 4,
					type: 'TMS'
				}, {
					id: 5,
					type: 'EBN'
				},
				{
					id: 6,
					type: 'LegecySystemAPI'
				},
				{
					id: 7,
					type: 'Sorter'
				},
				{
					id: 8,
					type: 'BagService'
				},
				{
					id: 9,
					type: 'FMBagging'
				},
				{
					id: 10,
					type: 'Investigation'
				}
			],
			hubzoneid: '',
			listHubZoneData: [],
			listSourceHubNameData: [],
			listSourceHubNameDataObj: {
				value: "",
				text: "",
				hubcode: ''
			},
			listHubZoneObjData: {
				value: "",
				text: ""
			}
		}
	},
	created: function() {},
	computed: {},
	filters: {
		moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		}
	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.warehouseid = userdetail[0].warehouseid;
		this.createdBy = userdetail[0].email;
		this.getHubZoneData();

		// this.loadTransactionalLogs()

	},
	methods: {
		onLogTypeChange() {
			if (this.logTypeData == 1) {
				this.appTypeArr = [{
					id: 3,
					type: 'HubOps'
				}]
			}
			else if (this.logTypeData == 11) {
				this.appTypeArr = [{
					id: 7,
					type: 'Sorter'
				}]
			} else {
				this.appTypeArr = [{
						id: 1,
						type: 'MasterAPI'
					},
					{
						id: 2,
						type: 'UpdateFramework'
					}, {
						id: 3,
						type: 'HubOps'
					}, {
						id: 4,
						type: 'TMS'
					}, {
						id: 5,
						type: 'EBN'
					},
					{
						id: 6,
						type: 'LegecySystemAPI'
					},
					{
						id: 8,
						type: 'BagService'
					},
					{
					id: 9,
					type: 'FMBagging'
				    },
					{
						id: 10,
						type: 'Investigation'
					}
				]
			}
		},
		getHubZoneData() {
			var self = this
			this.isLoading = true;
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					self.isLoading = false;
					var listHubZoneData = result.data.ResponseData;
					for (i = 0; i < listHubZoneData.length; i++) {
						this.listHubZoneData.push({
							value: listHubZoneData[i].hubzoneid,
							text: listHubZoneData[i].hubzonename
						})
					}
				}, error => {
					self.isLoading = false;
					console.error(error)
				})
		},
		selectedHubzone(hubData) {
			this.listHubZoneObjData = hubData
			this.hubzoneid = hubData.value;
			this.hubzonename = hubData.text;
			this.listSourceHubNameDataObj = {
				text: '',
				value: '',
				hubcode: ''
			}
            this.HubID=''
			this.$validator.validate('hubzoneid')
			if (this.hubzoneid != undefined) {
				this.getSourceHubNameList(this.hubzoneid)
			}
		},
		getSourceHubNameList() {
			this.hubLoading = 'Loading Hub...'
			this.listSourceHubNameData = [];
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				hubZoneId: this.hubzoneid
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading = ''
					var listSourceHubNameData = result.data.ResponseData;
					for (i = 0; i < listSourceHubNameData.length; i++) {
						this.listSourceHubNameData.push({
							value: listSourceHubNameData[i].HubID,
							text: listSourceHubNameData[i].HubCode + ' - ' + listSourceHubNameData[i].HubName + ' (' + listSourceHubNameData[i].HubID + ')',
							text1: listSourceHubNameData[i].HubName,
							hubcode: listSourceHubNameData[i].HubCode
						})

					}
				}, error => {
					console.error(error)
				})
		},
		selectedSourceHubName(selectedData) {

			this.listSourceHubNameDataObj = selectedData
			this.HubID = selectedData.value;
			// this.HubName = selectedData.text;

		},
		//
		// getHubList() {
		//   this.destinationhublist = [];
		//   this.hubLoading = 'Loading Hub...'
		//   this.input = {
		//     hubids: this.hubzoneid
		//   }
		//   axios({
		//       method: 'POST',
		//       url: apiUrl.xbmasterapi_url + 'hubservicecenter/list',
		//       data: this.input
		//     })
		//     .then(result => {
		//       this.hubLoading = ''
		//       this.HubDetails = result.data.data
		//       for (var i = 0; i < this.HubDetails.length; i++) {
		//         this.destinationhublist.push({
		//           "id": this.HubDetails[i].HubID,
		//           "text": this.HubDetails[i].HubName + ' (' + this.HubDetails[i].HubID + ')',
		//         })
		//         this.allHubMaster = this.destinationhublist;
		//         this.sourcehublist = this.destinationhublist;
		//         this.allHub = this.destinationhublist;
		//       }
		//     }, error => {
		//       console.error(error)
		//     })
		// },
		// SelectSourceHub(sourcehubitem) {
		//   this.sourcehubitem = sourcehubitem
		//   var a = this.sourcehubitem.id
		//   this.destinationhublist = this.allHubMaster.filter(function(el) {
		//     return el.id != a
		//   });
		//   if (this.sourcehubitem.text != '') {
		//     this.isSourceError = '',
		//       this.Sourceerrors = ''
		//   } else {
		//     this.isSourceError = '1',
		//       this.Sourceerrors = 'The Source Hub Name field is required.'
		//   }
		// },
		loadTransactionalLogs() {
			if (this.logTypeData == 1) {
				this.exceptionalCall()
			} else if (this.logTypeData == 2) {
				this.transcationalCall()
			}else if (this.logTypeData == 11) {
				this.sorterExceptionCall()
			} else {
				return false;
			}
		},
		transcationalCall() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.isLoading = true
					axios({
							method: 'GET',
							'url': apiUrl.allocateRuleapi_url + 'getAPITranscationLog?fromDate=' + this.fromdate.toISOString() + '&toDate=' + this.todate.toISOString() + '&logType=' + this.logTypeData + '&app=' + this.appTypeData + '&processLocation=' + this.listSourceHubNameDataObj.value + '&bagNo=' + this.bagno +
								'&shippingId=' + this.shippingid + '&pageNo=' + this.pageNo + '&pageSize=10',
							'data': this.input,
							headers: {
								'Authorization': 'authkey xB84JJ89Hd25'
							}
						})
						.then(result => {
							this.showExceptionLogTable = false;
							this.exceptionalLogsData = [];
							this.showSorterExceptionLogTable = false;
							this.sorterExceptionLogData = [];
							var response = result.data;
							this.isLoading = false;
							if (response.ResultCode == 100) {
								this.showTransactionLogTable = true;
								this.transactionalLogsData = response.ResponseData;
								this.totalRows = response.TotalCount
								if (this.totalRows < 10) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(this.totalRows / 10);
								}
							} else {
								this.showTransactionLogTable = false;
								this.transactionalLogsData = [];
								this.isLoading = false;
								this.$alertify.error(result.data.ReturnMessage)
							}
						}, error => {
							this.isLoading = false
							console.log(error)
						})
				}
			});
		},
		exceptionalCall() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.isLoading = true
					this.input = {}
					axios({
							method: 'GET',
							'url': apiUrl.allocateRuleapi_url + 'getExceptionLogDetails?fromDate=' + this.fromdate.toISOString() + '&toDate=' + this.todate.toISOString() + '&logType=' + this.logTypeData + '&app=HubOps&processLocation=' + this.listSourceHubNameDataObj.value + '&bagNo=' + this.bagno + '&shippingId=' + this.shippingid +
								'&pageNo=' + this.pageNo + '&pageSize=10',
							'data': this.input,
							headers: {
								'Authorization': 'authkey xB84JJ89Hd25'
							}
						})
						.then(result => {
							this.showTransactionLogTable = false;
							this.transactionalLogsData = [];
							this.showSorterExceptionLogTable = false;
							this.sorterExceptionLogData = [];
							var response = result.data
							this.isLoading = false;
							if (response.ResultCode == 100) {
								this.showExceptionLogTable = true;
								this.exceptionalLogsData = response.ResponseData;
								this.totalRows = response.TotalCount
								if (this.totalRows < 10) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(this.totalRows / 10);
								}
							} else {
								this.showExceptionLogTable = false;
								this.exceptionalLogsData = [];
								this.isLoading = false;
								this.$alertify.error(result.data.ReturnMessage)
							}
						}, error => {
							this.isLoading = false
							console.log(error)
						})
				}
			});
		},
		sorterExceptionCall() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.isLoading = true
					this.input = {}
					axios({
							method: 'GET',
							'url': apiUrl.allocateRuleapi_url + 'getSorterBagCloseExceptionLog?fromDate=' + this.fromdate.toISOString() + '&toDate=' + this.todate.toISOString() + '&logType=' + this.logTypeData + '&app=HubOps&processLocation=' + this.listSourceHubNameDataObj.value + '&bagNo=' + this.bagno + '&shippingId=' + this.shippingid +
								'&pageNo=' + this.pageNo + '&pageSize=10',
							'data': this.input,
							headers: {
								'Authorization': 'authkey xB84JJ89Hd25'
							}
						})
						.then(result => {
							this.showTransactionLogTable = false;
							this.showExceptionLogTable=false;
							this.transactionalLogsData = [];
							this.exceptionalLogsData=[];
							var response = result.data
							this.isLoading = false;
							if (response.ResultCode == 100) {
								this.showSorterExceptionLogTable = true;
								this.sorterExceptionLogData = response.ResponseData;
								this.totalRows = response.TotalCount
								if (this.totalRows < 10) {
									this.pageCount = 1
								} else {
									this.pageCount = Math.ceil(this.totalRows / 10);
								}
							} else {
								this.showSorterExceptionLogTable = false;
								this.sorterExceptionLogData = [];
								this.isLoading = false;
								this.$alertify.error(result.data.ReturnMessage)
							}
						}, error => {
							this.isLoading = false
							console.log(error)
						})
				}
			});
		},
		getPaginationData(pageNum) {
			this.pageNo = (pageNum - 1)
			if (this.logTypeData == 1) {
				this.exceptionalCall()
			} else if (this.logTypeData == 2) {
				this.transcationalCall()
			}
			else if (this.logTypeData == 11) {
				this.sorterExceptionCall()
			}else {
				return false;
			}
		},
		showRequestLog(data) {
			this.requestLogData = data;
			this.showRequestModal = true;
		},
		showResponseLog(data) {
			this.responseLogData = data;
			this.showResponseModal = true;
		},
		closeResponseModal() {
			this.showResponseModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		closeRequestModal() {
			this.showRequestModal = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		resetForm() {
			this.logTypeData = '';
			this.todate = '';
			this.fromdate = '';
			this.appTypeData = '';
			this.requestLogData = {};
			this.listHubZoneObjData = {
				value: "",
				text: ""
			};
			this.listSourceHubNameDataObj = {
				value: '',
				text: ''
			}
			this.bagno = ''
			this.shippingid = ''
			this.responseLogData = [];
			this.transactionalLogsData = [];
			this.exceptionalLogsData = [];
			this.showTransactionLogTable = false;
			this.showExceptionLogTable = false;
			this.showSorterExceptionLogTable=false;
			this.sorterExceptionLogData=[];
			this.$validator.reset();
			this.errors.clear();
			this.HubID=''
		},
		onSubmit: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.pageNo = 0
					this.loadTransactionalLogs()
				} else {
					console.log('errors exist', this.errors)
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/TransactionalLogs/TransactionalLogs.js